import FlexFormContainer from "../common/FlexFormContainer";
import { Controller, useForm } from "react-hook-form";
import {
  Button,
  Divider,
  Flex,
  Heading,
  SelectField,
  SwitchField,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { TagsInput } from "react-tag-input-component";
import { useNavigate } from "react-router-dom";
import { useUserQuery } from "../common/useUserQuery";
import { useAllergiesPostMutation } from "./api/useAllergiesMutation";
import { zodResolver } from "@hookform/resolvers/zod";
import { postAllergySchema } from "./validations/allergiesValidations";

export default function AllergiesAddPage() {
  const { data: userQueryData } = useUserQuery();
  const { mutate: allergiesPostMutation } = useAllergiesPostMutation();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      allergyName: "",
      allergyDescription: "",
      allergyLevel: "",
      reactions: [],
      derivatives: [],
      isActive: 0,
    },
    resolver: zodResolver(postAllergySchema),
  });

  const navigate = useNavigate();

  const onSubmit = (values) => {
    allergiesPostMutation({
      patientUserId: userQueryData?.patientUserId,
      ...values,
    });
    reset();
    navigate("/user/hr/allergies");
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FlexFormContainer headerTitle={"Allergy Details"}>
          <Flex
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Controller
              name="allergyName"
              control={control}
              render={({ field }) => (
                <TextField
                  minWidth="300px"
                  label="Allergy Name"
                  {...field}
                  errorMessage={errors.allergyName?.message}
                  hasError={!!errors.allergyName}
                />
              )}
            />
            <Controller
              name="allergyDescription"
              control={control}
              render={({ field }) => (
                <TextAreaField
                  minWidth="300px"
                  label="Allergy Description"
                  {...field}
                  errorMessage={errors.allergyDescription?.message}
                  hasError={!!errors.allergyDescription}
                />
              )}
            />
            <Controller
              name="allergyLevel"
              control={control}
              render={({ field }) => (
                <SelectField
                  minWidth="300px"
                  label="Allergy Level"
                  placeholder="Select"
                  {...field}
                  errorMessage={errors.allergyLevel?.message}
                  hasError={!!errors.allergyLevel}
                >
                  <option value=" Type I or anaphylactic reactions">
                    Type I or anaphylactic reactions
                  </option>
                  <option value="Type II or cytotoxic reactions">
                    Type II or cytotoxic reactions
                  </option>
                  <option value="Type III or immunocomplex reactions">
                    Type III or immunocomplex reactions
                  </option>
                  <option value=" Type IV or cell-mediated reactions">
                    Type IV or cell-mediated reactions
                  </option>
                </SelectField>
              )}
            />
            <Divider size="small" />
            <Heading level={7}>Reactions:</Heading>
            <Controller
              name="reactions"
              control={control}
              render={({ field }) => {
                return (
                  <TagsInput
                    placeHolder="Tags"
                    value={field?.value || []}
                    onChange={(tags) => field.onChange(tags)}
                  />
                );
              }}
            />
            <Divider size="small" />
            <Heading level={7}>Allergic to these derivatives:</Heading>
            <Controller
              name="derivatives"
              control={control}
              render={({ field }) => {
                return (
                  <TagsInput
                    placeHolder="Tags"
                    value={field?.value || []}
                    onChange={(tags) => field.onChange(tags)}
                  />
                );
              }}
            />
            <Controller
              name="isActive"
              control={control}
              render={({ field }) => (
                <SwitchField
                  label="Is Active"
                  labelPosition="end"
                  {...field}
                  isChecked={field.value === 1}
                  onChange={(event) =>
                    field.onChange(event.target.checked ? 1 : 0)
                  }
                />
              )}
            />
            <Button variation="primary" type="submit">
              Save
            </Button>
          </Flex>
        </FlexFormContainer>
      </form>
    </>
  );
}
